import { vulnerabilityPosts } from './feed/vulnerability';
import { malwarePosts } from './feed/malware';
import { toolsPosts } from './feed/tools';
import { ctfPosts } from './feed/ctf';
import { careerPosts } from './feed/career';
import { bugbountyPosts } from './feed/bugbounty';
import { redteamPosts } from './feed/redteam';

export const mockFeedPosts = [
  ...vulnerabilityPosts,
  ...malwarePosts,
  ...toolsPosts,
  ...ctfPosts,
  ...careerPosts,
  ...bugbountyPosts,
  ...redteamPosts
];